import { memoize } from "lodash";

import { getAvailableEntries } from "shared/catalog/AvailableCatalog/available-catalog.helper";

import { getComparatorData } from "./ComparatorHelper";

const getAvailableEntriesCache = memoize(getAvailableEntries);
const getComparatorDataCache = memoize(getComparatorData);

export const displayModelName = (
  modelSlug: string,
  particle: boolean = false,
) => {
  const isIphone = modelSlug.startsWith("iphone");

  return `${particle ? (isIphone ? "l'" : "le ") : ""}${modelSlug
    .replaceAll("-", " ")
    .replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase())
    .replaceAll("Iphone", "iPhone")}`;
};

/* Create canonical url ordered a -> z */
export const canonical = (leftModel: string, rightModel: string) => {
  const sorted = [leftModel, rightModel].sort();

  return `/compare/${sorted[0]}-vs-${sorted[1]}`;
};

export const smartphoneSlugs = memoize(() =>
  getComparatorDataCache().then(
    (comparatorData) => comparatorData?.modelDetails?.map(({ slug }) => slug),
  ),
);

export const smartphoneEntry = memoize((smartphone: string) =>
  getAvailableEntriesCache().then(
    (entries) =>
      entries?.find(({ slug }) => slug.replace("/", "") === smartphone) ?? null,
  ),
);

export const smartphoneDetail = memoize((smartphone: string) =>
  getComparatorDataCache().then(
    (comparatorData) =>
      comparatorData?.modelDetails?.find(({ slug }) => slug === smartphone) ??
      null,
  ),
);
